import React, { Component } from 'react';
import AntCollapse, { CollapseProps as AntCollapseProps } from 'antd/lib/collapse';

import styles from './Collapse.module.scss';

interface CollapseProps extends AntCollapseProps {}

class Collapse extends Component<CollapseProps> {
	static Panel: typeof AntCollapse.Panel;

	render() {
		return <AntCollapse {...this.props} className={styles.collapse} />;
	}
}

Collapse.Panel = AntCollapse.Panel;

export default Collapse;
